module.exports = __webpack_public_path__ + "static/media/ampleforth.5d56d4fe.svg";